import { createContext, useState } from "react";

export const DataContext = createContext({});



export const DataContextProvider = (props) => {
  const [contextData, setContextData] = useState({
    runes: "",    
  });

  const value = { contextData, setContextData };

  return (
    <DataContext.Provider value={value}>{props.children}</DataContext.Provider>
  )};